
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Slider } from "@/components/ui/slider";

interface DetailsFieldsProps {
  detalhes: {
    descricao?: string;
    garantia?: number;
    quantidadeMin?: number;
    quantidadeMax?: number;
    [key: string]: any;
  };
  setDetalhes: (value: {
    descricao?: string;
    garantia?: number;
    quantidadeMin?: number;
    quantidadeMax?: number;
    [key: string]: any;
  }) => void;
  showQuantidadeCampos?: boolean;
}

export const DetailsFields = ({ 
  detalhes, 
  setDetalhes,
  showQuantidadeCampos = true
}: DetailsFieldsProps) => {
  const handleChange = (field: string, value: string | number) => {
    setDetalhes({...detalhes, [field]: value});
  };

  return (
    <>
      <div className="grid gap-2">
        <Label htmlFor="descricao">Descrição (opcional)</Label>
        <Input
          id="descricao"
          value={detalhes.descricao || ""}
          onChange={(e) => handleChange('descricao', e.target.value)}
          placeholder="Descrição detalhada do item"
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="grid gap-2">
          <Label htmlFor="garantia">Garantia (anos)</Label>
          <Input
            id="garantia"
            type="number"
            min="0"
            value={detalhes.garantia || ""}
            onChange={(e) => handleChange('garantia', Number(e.target.value) || 0)}
            placeholder="Ex: 5"
          />
        </div>
        
        {showQuantidadeCampos && (
          <div className="grid gap-2">
            <Label htmlFor="quantidadeMin">Quantidade Mínima</Label>
            <Input
              id="quantidadeMin"
              type="number"
              min="1"
              value={detalhes.quantidadeMin || ""}
              onChange={(e) => handleChange('quantidadeMin', Number(e.target.value) || 1)}
              placeholder="Ex: 1"
            />
          </div>
        )}
      </div>
      
      {showQuantidadeCampos && (
        <div className="grid gap-2">
          <Label htmlFor="quantidadeMax">Quantidade Máxima (opcional)</Label>
          <Input
            id="quantidadeMax"
            type="number"
            min={detalhes.quantidadeMin || 1}
            value={detalhes.quantidadeMax || ""}
            onChange={(e) => handleChange('quantidadeMax', Number(e.target.value) || 0)}
            placeholder="Ex: 100"
          />
        </div>
      )}
    </>
  );
};
